import Swal from 'sweetalert2';

export class Alert {
    static error(message) {
        return Swal.fire({
            icon: 'error',
            title: 'Ups...',
            html: message,
            confirmButtonText: 'Esta bien',
            focusConfirm: true,
            allowOutsideClick: false
        });
    }

    static errorToast(msg){
        Swal.fire({
            icon: 'error', title: 'Ups...', text: msg, toast: true, position: 'top-end', timer: 2500, allowOutsideClick: false
        });
    }

    static success(message, titulo="Ok") {
        return Swal.fire({
            icon: 'success',
            title: titulo,
            html: message,
            confirmButtonText: 'Esta bien',
            focusConfirm: true,
            allowOutsideClick: false,
            width:"100%"
        });
    }

    static successToast(message){
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            html: message,
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            allowOutsideClick: false
        });
    }

    static confirm(message, title = "¿Está seguro?") {
        return Swal.fire({
            title: title,
            html: message,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            allowOutsideClick: false
        });
    }

}